var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const EXPENSES_API = "api/expenses";
export const create = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            return yield this.axiosInstance.post(EXPENSES_API, data, config);
        }
        catch (error) {
            console.error("Error fetching expenses create:", error);
            throw error;
        }
    });
};
export const createFromMovement = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.post(`${EXPENSES_API}/from-cashierbox-movement`, data, {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            });
        }
        catch (error) {
            console.error("Error creating expense from movement:", error);
            throw error;
        }
    });
};
export const linkCashierBoxMovement = function (expenseId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.post(`${EXPENSES_API}/${expenseId}/link-cashierbox-movement`, data, {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            });
        }
        catch (error) {
            console.error("Error linking expense movement:", error);
            throw error;
        }
    });
};
